
import React, { useState } from "react";
import PropTypes from "prop-types";
import "./Button.css";

const Button = ({ label, style, hoverStyle, activeStyle, ...props }) => {
  const [currentStyle, setCurrentStyle] = useState(style); // 追蹤當前樣式

  const handleMouseEnter = () => {
    if (hoverStyle) {
      setCurrentStyle({ ...style, ...hoverStyle });
    }
  };

  const handleMouseLeave = () => {
    setCurrentStyle(style); // 恢復為默認樣式
  };

  const handleMouseDown = () => {
    if (activeStyle) {
      setCurrentStyle({ ...style, ...activeStyle });
    }
  };

  const handleMouseUp = () => {
    if (hoverStyle) {
      setCurrentStyle({ ...style, ...hoverStyle });
    } else {
      setCurrentStyle(style);
    }
  };

  return (
    <button
      {...props}
      style={currentStyle}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
    >
      {label}
    </button>
  );
};

Button.propTypes = {
  /** 按鈕上的文字 */
  label: PropTypes.string.isRequired,
  /** 基本樣式 */
  style: PropTypes.object,
  /** 滑鼠懸停時的樣式 */
  hoverStyle: PropTypes.object,
  /** 點擊時的樣式 */
  activeStyle: PropTypes.object,
};

Button.defaultProps = {
  style: {},
  hoverStyle: null,
  activeStyle: null,
};

export default Button;
